const REASONS = [
  {
    icon: 'ri-map-pin-2-line',
    pill: 'icon-pill',
    color: 'text-teal-500',
    title: 'Florida Market Expertise',
    body: 'We know Florida markets, seasons, and local buyers.',
  },
  {
    icon: 'ri-tools-line',
    pill: 'icon-pill-orange',
    color: 'text-orange-500',
    title: 'AI-Native Execution',
    body: 'We do the work. We do not stop at advice.',
  },
  {
    icon: 'ri-line-chart-line',
    pill: 'icon-pill',
    color: 'text-teal-500',
    title: 'Transparent Reporting',
    body: 'You can see what is working, what is not, and what comes next.',
  },
  {
    icon: 'ri-rocket-2-line',
    pill: 'icon-pill-orange',
    color: 'text-orange-500',
    title: 'Early Mover Advantage',
    body: 'Most firms are late here. You can move first.',
  },
];

const STATS = [
  { value: '100%', cls: 'stat-value', label: 'Florida Only' },
  { value: '24/7', cls: 'stat-value-orange', label: 'Voice On' },
  { value: '48hr', cls: 'stat-value', label: 'Check In 48hr' },
  { value: '3x', cls: 'stat-value-orange', label: 'More Leads' },
];

export default function WhyUs() {
  return (
    <section id="why" className="relative py-28 overflow-hidden bg-white grid-bg">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at 85% 15%, rgba(20,184,166,0.16), transparent 55%), radial-gradient(ellipse at 15% 85%, rgba(249,115,22,0.10), transparent 55%)',
        }}
      ></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="eyebrow reveal">Why Florida AI Marketing Experts</div>
          <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] reveal">
            Find the Leak. Fix the Leak.<br />Get More Leads.
          </h2>
          <p className="mt-6 text-slate-600 font-body font-light text-base md:text-lg reveal">
            We keep it simple. No jargon, no fluff — just the work that moves the number.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
          {REASONS.map((r) => (
            <div key={r.title} className="glass rounded-2xl p-6 reveal">
              <div className={`${r.pill} mb-4`}>
                <i className={`${r.icon} ${r.color} text-lg`}></i>
              </div>
              <h4 className="h-display text-2xl leading-tight">{r.title}</h4>
              <p className="mt-3 text-slate-600 font-body font-light text-sm leading-relaxed">{r.body}</p>
            </div>
          ))}
        </div>

        <div className="glass-strong rounded-3xl p-10 md:p-14 reveal">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {STATS.map((s) => (
              <div key={s.label}>
                <div className={`h-display text-5xl md:text-6xl lg:text-7xl ${s.cls} leading-none`}>
                  {s.value}
                </div>
                <div className="mt-3 text-slate-500 font-body font-light text-sm">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
